function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAAA IDP Payment page
 * 
 */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import './Footer.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Footer extends React.Component {
  constructor(...args) {
    super(...args);
    /**
     * Print
     */
    _defineProperty(this, "print", e => {
      e.preventDefault();
      window.print();
    });
    /**
     * restart app
     */
    _defineProperty(this, "restart", e => {
      e.preventDefault();
      window.location.href = window.location.origin;
    });
  }
  render() {
    const {
      apiSuccess,
      status
    } = this.props;
    if (status === null) return null;
    const printButton = window.innerWidth >= 768 ? /*#__PURE__*/_jsxs("a", {
      href: "/confirmation#print",
      className: "button reverse print",
      onClick: this.print,
      role: "button",
      tabIndex: "0",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "print"
      }), "Save / Print"]
    }) : null;
    const applyButton = status === 'success' && apiSuccess === 'true' ? /*#__PURE__*/_jsxs("a", {
      href: "/confirmation#restart",
      className: "button restart",
      onClick: this.restart,
      tabIndex: "0",
      role: "button",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "id-card"
      }), "Apply for another permit"]
    }) : null;
    const tryAgainButton = status === 'fail' && apiSuccess === 'true' ? /*#__PURE__*/_jsxs(Link, {
      className: "button payment",
      to: "/payment",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "redo"
      }), "Try payment again"]
    }) : null;
    return /*#__PURE__*/_jsxs("section", {
      className: "footer",
      children: [printButton, applyButton, tryAgainButton]
    });
  }
}
_defineProperty(Footer, "defaultProps", {
  apiSuccess: 'false',
  status: ''
});
export default Footer;